<div class="page-wrapper" [ngClass]="{'modal': isLoginModal, 'page': !isLoginModal}">
  <ion-header>
    <ion-toolbar class="toolbar-header">
      @if(isLoginModal){
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="goBack()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      } @else {
        <ion-buttons slot="start">
          <ion-button>
            <ion-back-button defaultHref="/auth"></ion-back-button>
          </ion-button>
        </ion-buttons>
      }
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="content">
     <div class="header">
      <figure>
        <img [src]="logoSquare"
          alt="logo" />
      </figure>
      <h2 class="title">{{'Sign In' | translate}}</h2>
      
    </div>
    <div class="signin-form" *ngIf="isEmailLogin || isPhoneLogin">

        <form class="signin-with-email-form" *ngIf="isEmailLogin" [formGroup]="signinWithEmailForm" (ngSubmit)="onSignIn()">
          <ion-item class="input-item" [class.ion-invalid]="isEmailInvalid">
            <!-- <ion-label position="floating">Email or Phone</ion-label> -->
            <div class="center-element">
              <ion-input type="email" labelPlacement="floating" label="{{'Email' | translate}}" name="email" formControlName="email"></ion-input>
              <!-- biometric Login code will use in future -->
              <!-- <div class="finger-wrapper" (click)="biometricLogin()">
                <ion-icon name="finger-print-outline"></ion-icon>
                <div class="scan-person-iocons">
                  <ion-icon name="scan-outline"></ion-icon>
                  <ion-icon class="person-outline" name="person"></ion-icon>
                </div>                
              </div> -->
            </div>
          </ion-item>

          <ion-item class="input-item" [class.ion-invalid]="isPasswordInvalid">
            <!-- <ion-label position="floating">Password</ion-label> -->
            <div class="center-element">
              <ion-input labelPlacement="floating" name="Password"  label="{{'PASSWORD' | translate}}" formControlName="password" [type]="showPassword ? 'text' : 'password'"></ion-input>
              <ion-icon slot="end" [name]="showPassword ? 'eye' : 'eye-off'" (click)="togglePasswordVisibility()" class="eye-icon"></ion-icon>
            </div>
            <ion-note slot="error" *ngIf="isPasswordInvalid">
            <div *ngIf="password?.errors?.['required']">{{'Password is required' | translate}}</div>
            <div *ngIf="password?.errors?.['minlength']">{{'Password must be at least 6 characters' | translate}}</div>
          </ion-note>
        </ion-item>
          <div class="forgot-password" (click)="forgotPassword()">{{'Forgot password' | translate}}</div>
        </form>

        <form class="signin-form" *ngIf="isPhoneLogin" [formGroup]="signinWithPhoneForm" (ngSubmit)="onSignInWithPhone()">
        <ion-row>
          <ion-col size="4">
          <ion-item (click)="getCountryCode()" class="input-item">
              <ion-input formControlName="country_code" labelPlacement="stacked" label="{{'Country' | translate}}" 
                  [value]="signinWithPhoneForm.get('country_code')?.value">
              </ion-input>
              <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
          </ion-item>
          </ion-col>
          <ion-col size="8">
          <ion-item class="input-item">
              <ion-input inputmode="numeric" formControlName="phone" placeholder="Area code + Phone" labelPlacement="stacked" label="{{'Phone' | translate}}"
                  [value]="signinWithPhoneForm.get('phone')?.value">
              </ion-input>
          </ion-item>
          </ion-col>
        </ion-row>
          <ion-item class="input-item" [class.ion-invalid]="isPasswordInvalid">
          <div class="center-element">
            <ion-input labelPlacement="floating" name="Password"  label="{{'PASSWORD' | translate}}" formControlName="password" [type]="showPassword ? 'text' : 'password'"></ion-input>
            <ion-icon slot="end" [name]="showPassword ? 'eye' : 'eye-off'" (click)="togglePasswordVisibility()" class="eye-icon"></ion-icon>
          </div>
          <ion-note slot="error" *ngIf="isPasswordInvalid">
          <div *ngIf="password?.errors?.['required']">{{'Password is required' | translate}}</div>
          <div *ngIf="password?.errors?.['minlength']">{{'Password must be at least 6 characters' | translate}}</div>
        </ion-note>
      </ion-item>
      <div class="forgot-password" (click)="forgotPassword()">{{'Forgot password' | translate}}</div>
      </form>

    </div>
    <app-sso-buttons 
      *ngIf="!isEmailLogin && !isPhoneLogin"
      (ssoLogin)="loginWithSSO($event)"
      (continueWithEmail)="continueWithEmail()"
      (continueWithPhone)="continueWithPhone()"
      [emailBtnText]="'Continue with Email/phone'"
      [isLoginModal]="true">
    </app-sso-buttons>
  <ion-footer *ngIf="isEmailLogin || isPhoneLogin">
    <ion-button 
      expand="block" 
      class="primary-button"
      type="submit"
      [disabled]="isLoading || (isEmailLogin ? signinWithEmailForm.invalid : signinWithPhoneForm.invalid)"
      (click)="onSignIn()">
      <span>{{'Sign In' | translate}}</span>
    </ion-button>
  </ion-footer>
<div></div>
</div>
  </ion-content>

</div>